import ConnectionProps from './ConnectionProps'

export default {
    name: 'kendo-diagram-connection',
    render () {
        return null
    },
    mixins: [ConnectionProps]
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagramConnection/index.js